import React from 'react';

import ServicesList from '../ServicesList/ServicesList';
import Content from '../UI/Content/Content';
import Type from '../UI/Type/Type';
import QuestionList from '../QuestionList/QuestionList';
import * as styles from './FaqBody.module.scss';

const FaqBody = ({ title, body, relatedServices, relatedNodes }) => {
  return (
    <>
      <h1 className={styles.heading}>{title}</h1>

      {body && (
        <div className={styles.content}>
          <Content hasLead={false} items={body} />
        </div>
      )}

      {!!relatedServices && (
        <>
          <Type.MetaHeading>Related service(s)</Type.MetaHeading>
          <ServicesList nodes={relatedServices} />
        </>
      )}

      {relatedNodes.length > 0 &&
        <>
          <Type.MetaHeading>Related FAQ(s)</Type.MetaHeading>
          <QuestionList count={1} nodes={relatedNodes} isChunked/>
        </>
      }
    </>
  );
};

export default FaqBody;
